/**
 * useFeatureFlag — hook to read a single feature flag.
 *
 * Returns true only when the flag is explicitly enabled.
 * Returns false (safe default) while loading or for disabled flags.
 *
 * Usage:
 *   const isNewLandingEnabled = useFeatureFlag('enable_new_landing_page');
 */
import { useFeatureFlags, FeatureFlags } from '../contexts/FeatureFlagsContext';

export function useFeatureFlag(flagName: keyof FeatureFlags): boolean {
  const { flags, ready } = useFeatureFlags();
  if (!ready) return false;
  return flags[flagName] === true;
}
